import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { FormGroup, Validators, FormBuilder } from "@angular/forms";
import { ApiService } from '../api.service';
import { HelperService} from '../helper.service';
import { MakeEnquriyComponent} from '../make-enquriy/make-enquriy.component';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-success-enquriy',
  templateUrl: './success-enquriy.component.html',
  styleUrls: ['./success-enquriy.component.scss']
})
export class SuccessEnquriyComponent implements OnInit {
  encryptEnqID:string;
  enquiryID:string;
  partyID:string;
  vendorID:string;
  closeResult:string;
  

  constructor(private activatedRoute: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    private apiService: ApiService,
    private helperService:HelperService,
    private modalService: NgbModal) {

     

      this.enquiryID = this.activatedRoute.snapshot.paramMap.get("enquiryID");     
      this.partyID = this.activatedRoute.snapshot.paramMap.get("partyID"); 
      this.vendorID = this.activatedRoute.snapshot.paramMap.get("vendorID");      
      
      
      let enquiryData = {

        token: this.helperService.getToken(),
        userID: this.helperService.getUserID(),
        hostID: this.helperService.getHostID(),
        enquiryID: this.enquiryID,
        partyID: this.partyID,
        vendorID: this.vendorID
      }

      this.apiService.hostEnquiryDetails(enquiryData).subscribe((res:any)=>{       
        

        this.enquiryID = res.data.enquiryDetailsData.data.enqueryDetail[0].id;
        this.partyID = res.data.enquiryDetailsData.data.enqueryDetail[0].partyId;
        this.vendorID = res.data.enquiryDetailsData.data.vendorDetails[0].id;
        
      })

   }


   ngOnInit() {
  }

   ViewEnquiryDetails(enquiryID,partyID,vendorID){
     this.router.navigateByUrl(`enquiry-details/`+ this.enquiryID + `/` + this.partyID + `/` + this.vendorID, { skipLocationChange: true});
   }

   getEqNumber() {
    if (!this.enquiryID) {
      return "";
    }
    return "SC-EQ-" + this.enquiryID.toString().padStart(8, "0");
  }



  open(content) {
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }

  

}
